import { Box, Divider, Switch } from '@chakra-ui/react'
import { Dispatch, SetStateAction } from 'react'

import { FormField } from '../../../../components/FormField'
import { RichTextField } from '../../../../components/RichTextField'
import { SectionTitle } from '../../../../components/SectionCard'
import { TARGET_AUDIENCE_HINT, TOPICS_HINT } from '../contentHints'
import { IEventForm } from './eventFormShared'

interface IProps {
  form: IEventForm
  setForm: Dispatch<SetStateAction<IEventForm>>
  fieldErrors: Record<string, string[]>
  saving: boolean
}

export function ContentTab({ form, setForm, fieldErrors, saving }: IProps) {
  return (
    <>
      <RichTextField
        label="Copy do Evento"
        value={form.copy}
        onChange={(copy) => setForm({ ...form, copy })}
        placeholder="Escreva a copy do evento aqui..."
        minH="200px"
      />

      <RichTextField
        label="A quem se destina"
        value={form.target_audience}
        onChange={(target_audience) => setForm({ ...form, target_audience })}
        placeholder="Escreva a quem se destina o evento aqui..."
        helperText={TARGET_AUDIENCE_HINT}
        minH="200px"
        mt={5}
      />

      <RichTextField
        label="Temas abordados"
        value={form.topics}
        onChange={(topics) => setForm({ ...form, topics })}
        placeholder="Escreva os temas abordados no evento aqui..."
        helperText={TOPICS_HINT}
        minH="200px"
        mt={5}
      />

      <Divider mt={5} mb={5} />
      <SectionTitle>Termo</SectionTitle>

      <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" alignItems="center" gap={3}>
          <FormField label="Incluir termo" htmlFor="use_term" mb={0}>
            <Switch
              id="use_term"
              isChecked={form.use_term}
              onChange={(e) =>
                setForm({ ...form, use_term: e.target.checked, term: e.target.checked ? (form.term ?? '') : null })
              }
              isDisabled={saving}
            />
          </FormField>
        </Box>

        {form.use_term && (
          <RichTextField
            label="Conteúdo do termo"
            error={fieldErrors['term']?.[0]}
            value={form.term ?? ''}
            onChange={(term) => setForm({ ...form, term })}
            placeholder="Escreva o termo aqui..."
            minH="300px"
          />
        )}
      </Box>
    </>
  )
}
